import React, { type ReactNode } from 'react';

import IntlMessagesProvider from '@atlaskit/intl-messages-provider/main';

import { messages as requestReasonMessages } from '../../ui/shared/premium-trial-request-reason-messages';
import { examplesSectionFallbackMessages } from './examples-section-fallback-messages';
import { defaultLocale, fetchMessagesForLocale } from './fetch-messages-for-locale';
import { popupFallbackMessages } from './popup-fallback-messages';
import { standardBenefitsFallbackMessages } from './standard-benefits-fallback-messages';

const defaultMessagesWithStandardBenefits = {
	...defaultLocale,
	...standardBenefitsFallbackMessages,
	...examplesSectionFallbackMessages,
	...popupFallbackMessages,
	[requestReasonMessages.label.id]: requestReasonMessages.label.defaultMessage,
	[requestReasonMessages.helperText.id]: requestReasonMessages.helperText.defaultMessage,
};

export const IntlProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
	return (
		<IntlMessagesProvider
			defaultMessages={defaultMessagesWithStandardBenefits}
			loaderFn={fetchMessagesForLocale}
		>
			{children}
		</IntlMessagesProvider>
	);
};
